import type {ReactElement} from 'react';
import {useContext} from 'react';
import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import type {EventWizardDescriptionMarkdownProps} from '@Components/event-wizard/event-wizard-description-markdown/event-wizard-description-markdown.types';
import styles from './event-wizard-description-markdown.module.scss';
import './markdown-custom-style.scss';
import {EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT} from '@Components/event-wizard/event-wizard-container-queries-context';

export function EventWizardDescriptionMarkdown({description, onUpdate, isErrorState = false}: EventWizardDescriptionMarkdownProps): ReactElement<any> {
  const {isExtraSmallScreen} = useContext(EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT);

  const modules = {
    toolbar: [[{header: [2, 3, false]}], ['bold', 'italic', 'underline'], [{list: 'ordered'}, {list: 'bullet'}], ['link']],
  };
  const formats = ['header', 'bold', 'italic', 'underline', 'ordered', 'list', 'link'];

  return (
    <ReactQuill
      theme="snow"
      className={`${styles.container} ${isExtraSmallScreen ? 'xsmall-mobile' : ''} ${isErrorState ? '-error' : ''} spacing-m-b-3`}
      value={description}
      modules={modules}
      formats={formats}
      onChange={(value: string) => {
        onUpdate(value);
      }}
    />
  );
}
